import axios from 'axios';
import React, { createContext, useContext, useEffect, useState } from 'react';

axios.defaults.withCredentials = true;

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AuthContext = createContext(null);

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be inside AuthProvider');
  return ctx;
};

// Attach saved token on axios boot (before provider mounts)
const savedToken = typeof window !== 'undefined' && localStorage.getItem('admin_token');
if (savedToken) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${savedToken}`;
}

export const AuthProvider = ({ children }) => {
  // null = checking, false = not authed, object = admin user
  const [admin, setAdmin] = useState(null);

  const checkAuth = async () => {
    try {
      const { data } = await axios.get(`${API}/auth/me`);
      setAdmin(data);
    } catch (e) {
      setAdmin(false);
    }
  };

  useEffect(() => {
    checkAuth();
  }, []);

  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/auth/login`, { email, password });
    if (data.token) localStorage.setItem('admin_token', data.token);
    axios.defaults.headers.common['Authorization'] = `Bearer ${data.token}`;
    setAdmin({ email: data.email, role: data.role });
    return data;
  };

  const logout = async () => {
    try { await axios.post(`${API}/auth/logout`); } catch (e) {}
    localStorage.removeItem('admin_token');
    delete axios.defaults.headers.common['Authorization'];
    setAdmin(false);
  };

  return (
    <AuthContext.Provider value={{ admin, login, logout, checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
};
